module.exports = __webpack_public_path__ + "img/82.f45f1164.jpg";